import React from "react";
import ModalFrame from "./ModalFrame";
import useDiscardGuard from "./useDiscardGuard";

// Gecentreerde dialoog.
//
// Props: open, title, onClose, footer, width (px, standaard 560), children,
//   initialFocusRef (optioneel: element dat bij openen focus krijgt),
//   dirty (optioneel: bij sluiten eerst "Wijzigingen weggooien?").
// Toegankelijk: focus-trap, startfocus, focus terug naar de trigger, Esc sluit,
// aria-modal + aria-labelledby. Z-index: --z-overlay; geopend boven een andere
// dialoog (bv. vanuit een Drawer) --z-dialog (zie ModalFrame).
export default function Modal({ open, title, onClose, footer, width = 560, dirty = false, initialFocusRef, children }) {
  const [requestClose, guard] = useDiscardGuard(dirty, onClose);
  return (
    <>
      <ModalFrame
        open={open}
        title={title}
        onClose={requestClose}
        footer={footer}
        width={width}
        variant="modal"
        initialFocusRef={initialFocusRef}
      >
        {children}
      </ModalFrame>
      {open ? guard : null}
    </>
  );
}
